import Input from '@/common/components/base/input/base/Input.tsx';
import formResetAttachment from '@/common/components/base/input/base/attachments/FormResetAttachment.tsx';
import { convertToEnglishDigits } from '@/common/components/base/input/base/changeHandlers/convertToEnglishDigits';
import { TextInputType } from '@/common/components/base/input/textInput/TextInput.type.ts';
import searchAttachment from '@/common/components/base/input/textInput/attachments/searchAttachment.tsx';
import { ChangeEventHandler, useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';

const TextInput = ({
  name,
  rules,
  label,
  placeholder,
  onChange,
  disabled,
  hasSearchAttachment = false,
  defaultValue = '',
  direction,
  placeholderAlign,
  optionalLabel,
  max,
  hasLabel,
  noCharInput = false,
  isTextNumber = false,
  inputProps,
  hasErrorMassage,
}: TextInputType) => {
  const { control, setValue, trigger, getValues, clearErrors } =
    useFormContext();
  const controller = useController({
    rules,
    control,
    name,
    defaultValue,
  });

  const { field, fieldState } = controller;
  const inputOnChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    let value = convertToEnglishDigits(e.target.value);
    if (noCharInput) {
      const transformedInput = value.replace(/\D/g, '');
      field.onChange(transformedInput);
      onChange?.(transformedInput);
    } else {
      field.onChange(value);
      onChange?.(value);
    }
  };
  const onReset = () => {
    field.onChange('');
    clearErrors(name);
    onChange?.('');
  };

  useEffect(() => {
    if (isTextNumber && !getValues(name)) {
      setValue(name, '0');
      trigger(name);
    }
  }, []);

  return (
    <Input
      hasLabel={hasLabel}
      inputProps={{
        value: field.value,
        onChange: inputOnChange,
        placeholder,
        disabled,
        maxLength: max,
        type: 'text',
        inputMode: noCharInput ? 'numeric' : 'text',
        onFocus: (e) => {
          if (e.target.value === '0' && isTextNumber) e.target.value = '';
        },
        onBlur: (e) => {
          if (e.target.value === '' && isTextNumber) e.target.value = '0';
        },
        ...inputProps,
      }}
      optionalLabel={optionalLabel}
      inputRef={field.ref}
      errorMessage={fieldState.error?.message}
      label={label}
      direction={direction}
      placeholderAlign={placeholderAlign}
      endAttachments={[
        formResetAttachment({
          onReset,
          renderCondition: !!field.value && !disabled,
        }),
        searchAttachment({
          shouldRender: hasSearchAttachment && (!field.value || !!disabled),
        }),
      ]}
      hasErrorMassage={hasErrorMassage}
    />
  );
};

export default TextInput;
